import React, { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface Props {
  columns?: any;
  formControls: any;
  userFormData: any;
  cancelRoute: any;
  customClass?: any;
  custom_btn_text?: string;
  isEdit?: boolean;
  isView?: boolean;
  editData?: any;
  customClearButton?: any;
  clearStatus?: any;
  loading?: any;
  button_columns?: any;
  onChildEvent?: (data: string) => void;
  isNotEmptyFormAfterSubmit?: boolean;
  onParentDropdownEvent?: (data: any) => void;
  onCancelEvent?: () => void;
  onFormSubmitEvent?: (data: any) => void;
}

export const DynamicForm = (props: Props) => {
  const [formData, setFormData] = useState<any>({});
  const [formValues, setFormValues] = useState<any>({});
  const [isformSubmit, setIsFormSubmit] = useState<boolean>(false);
  const [clearStatus, setClearStatus] = useState<boolean>(true);
  const [errors, setErrors] = useState<any>({});
  const navigate = useNavigate();
  const [formFieldsArray, setFormFieldsArray] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  // useEffect(() => {
  //   const formsValues: any = {};
  //   formFieldsArray.forEach((element: any) => {
  //     formsValues[element.name] = element.value;
  //   });
  //   setFormData(formsValues);
  //   setFormFieldsArray([...props?.userFormData]);
  // }, [props]);

  useEffect(() => {
    const input = props?.userFormData;
    let fieldsArray: any = [];
    if (Array.isArray(input)) {
      fieldsArray = input;
    } else if (input && typeof input === "object") {
      fieldsArray = Object.entries(input).map(([name, value]) => ({
        name,
        value,
      }));
    }
    const formsValues: any = {};
    fieldsArray.forEach((element: any) => {
      formsValues[element.name] = element.value;
    });

    setFormData(formsValues);
    setFormFieldsArray(fieldsArray);
  }, [props]);

  const handleInput = (e: any, index: number, data: any) => {
    const formData = formFieldsArray;
    const { name, value } = e.target;
    setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));

    const field = formFieldsArray[index];
    const { regex, label } = field;
    const newErrors: any = { ...errors };

    if (regex && value && !RegExp(regex).test(value)) {
      newErrors[name] = data?.onChangeError
        ? data?.onChangeError
        : `Please enter a valid ${label?.toLowerCase()}`;
    } else {
      delete newErrors[name];
    }
    formData[index].value = value;
    setFormFieldsArray([...formData]);
    setErrors(newErrors);
    if (field?.isParendDropDown) {
      if (props?.onParentDropdownEvent) {
        props?.onParentDropdownEvent({ name, value });
      }
    }
  };

  const onChangeImage = (data: any) => {
    if (props?.onParentDropdownEvent) {
      props?.onParentDropdownEvent(data);
    }
  };

  const onClickSubmit = (e: any) => {
    e.preventDefault();
    setLoading(true);
    setIsLoading(true);
    const isValid = validateForm();
    console.log("form index:", isValid);
    if (isValid) {
      setErrors({});
      const data: any = { formData, type: props.isEdit ? "edit" : "create" };

      console.log("form index:", data);
      if (props?.onChildEvent) {
        props?.onChildEvent(data);
      }
      if (!props?.isNotEmptyFormAfterSubmit) {
        formFieldsArray.forEach((element: any) => {
          element.value = "";
        });
      }
      setLoading(false);
      setIsLoading(false);
    } else {
      setLoading(true);
      setIsLoading(true);
      setTimeout(() => {
        setLoading(false);
        setIsLoading(false);
      }, 500);

      // Display errors
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors: any = {};

    formFieldsArray?.forEach((field: any) => {
      const { name, label, required, regex, error, title } = field;
      const value =
        typeof formData[name] === "string"
          ? formData[name]?.trim() || field.value
          : formData[name] || field.value;
      // if (required && (!value || value === "")) {
      //   newErrors[name] = error || `Please enter a ${label.toLowerCase()}`;
      //   isValid = false;
      // }
      // if (regex && value && !RegExp(regex).test(value)) {
      //   newErrors[name] = field?.onChangeError
      //     ? field?.onChangeError
      //     : error || `Please enter a valid ${label.toLowerCase()}`;
      //   isValid = false;
      // }
      if (required && (!value || value === "" || value.length === 0)) {
        let defaultErrorMessage = "";
        switch (title) {
          case "dropdown":
          case "multiDropdown":
            defaultErrorMessage = `Please select a ${label?.toLowerCase()}`;
            break;
          case "checkbox":
            defaultErrorMessage = `Please check the ${label?.toLowerCase()}`;
            break;
          default:
            defaultErrorMessage = `Please enter a ${label?.toLowerCase()}`;
        }
        newErrors[name] = error || defaultErrorMessage;
        isValid = false;
      }
      if (regex && value && !RegExp(regex).test(value)) {
        newErrors[name] = field?.onChangeError
          ? field?.onChangeError
          : error || `Please enter a valid ${label?.toLowerCase()}`;
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const onClickCancel = () => {
    if (props.cancelRoute !== "Action") {
      navigate(props.cancelRoute);
    } else {
      if (props?.onCancelEvent) {
        props?.onCancelEvent();
      }
    }
  };

  const onClickClear = (event: any) => {
    props.clearStatus(clearStatus);
  };
  const handleFileUploadInput = (e: any, index: number, data: any) => {
    const formData: any = new FormData();
    formData.append("file", e.target.files[0], "copuns");
    // UPLOAD_FILE(formData, () => {}).then((res: any) => {
    //   const formData = formFieldsArray;
    //   const { name, value } = e.target;
    //   setFormData((prevData: any) => ({
    //     ...prevData,
    //     [name]: `${res.data.base_url}${res.data.url}`,
    //   }));

    //   // const field = formFieldsArray[index];
    //   // const { regex, label } = field;
    //   // const newErrors: any = { ...errors };

    //   // if (regex && value && !RegExp(regex).test(value)) {
    //   //   newErrors[name] = data?.onChangeError
    //   //     ? data?.onChangeError
    //   //     : `Please enter a valid ${label.toLowerCase()}`;
    //   // } else {
    //   //   delete newErrors[name];
    //   // }
    //   formData[index].value = `${res.data.base_url}${res.data.url}`;
    //   setFormFieldsArray([...formData]);
    // });
  };

  const onSelect = (
    selectedList: any,
    selectedItem: any,
    index: number,
    element: any
  ) => {
    const formFields = formFieldsArray;
    if (selectedItem.value === "ALL") {
      formFields[index].value = formFields[index].option;
      setFormData((prevData: any) => ({
        ...prevData,
        [element]: formFields[index].option,
      }));
      if (props?.onParentDropdownEvent) {
        props?.onParentDropdownEvent({
          data: formFields[index].option,
          isApi: formFields[index].isApiCall,
        });
      }
    } else {
      setFormData((prevData: any) => ({
        ...prevData,
        [element]: selectedList,
      }));
      if (props?.onParentDropdownEvent) {
        props?.onParentDropdownEvent({
          data: selectedList,
          isApi: formFields[index].isApiCall,
          name: element,
        });
      }
    }
    setFormFieldsArray([...formFields]);
  };

  const onRemove = (
    selectedList: any,
    removedItem: any,
    index: number,
    element: any
  ) => {
    const formFields = formFieldsArray;
    if (removedItem.value === "ALL") {
      if (props?.onParentDropdownEvent) {
        props?.onParentDropdownEvent({
          data: [],
          isApi: formFields[index].isApiCall,
        });
      }
    } else {
      setFormData((prevData: any) => ({
        ...prevData,
        [element]: selectedList,
      }));
      if (props?.onParentDropdownEvent) {
        props?.onParentDropdownEvent({
          data: selectedList,
          isApi: formFields[index].isApiCall,
          name: element,
        });
      }
    }
    setFormFieldsArray([...formFields]);
  };

  const onFormSubmit = (
    e: any,
    btnObj: any,
    index: number,
    subIndex: number
  ) => {
    if (btnObj.isCheckFormValidation) {
      e.preventDefault();
      const isValid = validateForm();
      if (isValid) {
        setErrors({});
        const data: any = { formData, type: btnObj?.action };
        if (props?.onFormSubmitEvent) {
          props?.onFormSubmitEvent(data);
        }
        if (!props?.isNotEmptyFormAfterSubmit) {
          formFieldsArray.forEach((element: any) => {
            element.value = "";
          });
        }
      }
    } else {
      const data: any = { formData, type: btnObj?.action, index, subIndex };
      if (props?.onFormSubmitEvent) {
        props?.onFormSubmitEvent(data);
      }
    }
  };

const getFormArray = (formDataArray: any) => {
  return formDataArray?.fields?.map((item: any) => {
    const keyField = item?.fields?.find((field: any) => field.name === "key");
    const valueField = item?.fields?.find(
      (field: any) => field?.name?.toLowerCase() === "value"
    );

    if (!keyField || !valueField) return null;

    return {
      key: keyField.value,
      value: valueField.value,
    };
  })?.filter(Boolean) ?? [];
};

  const handleSubElementInput = (
    e: any,
    index: number,
    subIndex: number,
    subSubIndex: number,
    subData: any,
    data: any
  ) => {
    const formDataArray = [...formFieldsArray];
    const { name, value } = e.target;

    const field = formFieldsArray[index];

    const { regex, label } = field || {};
    const newErrors: any = { ...errors };

    // Validate regex
    if (regex && value && !RegExp(regex).test(value)) {
      newErrors[name] = `Please enter a valid ${label?.toLowerCase()}`;
    } else {
      delete newErrors[name];
    }

    // Additional validation
    formDataArray?.forEach((el: any) => {
      if (el?.name === "event_start_date") {
        if (el?.value === "" && field?.isEndDataValidate) {
          newErrors["event_start_date"] = `Please select start date`;
        } else {
          delete newErrors[name];
        }
      }
    });

    // ✅ Safely access and update the field's value
    if (
      formDataArray[index] &&
      formDataArray[index].fields &&
      formDataArray[index].fields[subIndex] &&
      formDataArray[index].fields[subIndex].fields &&
      formDataArray[index].fields[subIndex].fields[subSubIndex]
    ) {
      formDataArray[index].fields[subIndex].fields[subSubIndex].value =
        data?.type === "checkbox" ? e.target.checked : value;
    } else {
      console.warn("Invalid index access in formDataArray");
      return;
    }

    // Update state
    setFormData((prevData: any) => ({
      ...prevData,
      [data?.name]: getFormArray(formDataArray[index]),
    }));
    setFormFieldsArray(formDataArray);
    setErrors(newErrors);

    if (field?.isParentDropDown && props?.onParentDropdownEvent) {
      props.onParentDropdownEvent(value);
    }
  };


  return (
    <div className="row px-2">
      {formFieldsArray?.map((data: any, index: number) => (
        <React.Fragment key={index}>
          {data.title === "input" && (
            <div className={`col-md-${12 / props?.columns} mb-2`}>
              <label className="form-label d-flex justify-content-start">
                {data.label}
                {data.required && (
                  <span className="text-danger fw-bold mx-2">
                    {data.hide_mandtory_field ? <span></span> : <span>*</span>}
                  </span>
                )}
              </label>
              <input
                type={data.type}
                name={data.name}
                className={`${data?.class ? data?.class : "form-control"} `}
                placeholder={data.placeholder}
                onChange={(event) => {
                  handleInput(event, index, data);
                }}
                required={data.required}
                maxLength={data.maxLength}
                value={data.value}
                disabled={data?.disabled ? data?.disabled : false}
              />
              {Object.keys(errors).length > 0 && (
                <div
                  className="text-danger text-start mt-1"
                  style={{ fontSize: "13px" }}
                >
                  {errors[data.name] || ""}
                </div>
              )}
            </div>
          )}
          {data.title === "file" && (
            <div className={`col-md-${12 / props?.columns} mb-2`}>
              <label className="form-label d-flex justify-content-start">
                {data.label}
                {data.required && (
                  <span className="text-danger fw-bold mx-2">
                    {data.hide_mandtory_field ? <span></span> : <span>*</span>}
                  </span>
                )}
              </label>
              <div className="position-relative">
                <input
                  type={data.type}
                  name={data.name}
                  className={`${data?.class ? data?.class : "form-control"} `}
                  placeholder={data.placeholder}
                  onChange={(event) => {
                    handleFileUploadInput(event, index, data);
                  }}
                  required={data.required}
                  maxLength={data.maxLength}
                  // value={data.value}
                  disabled={data?.disabled ? data?.disabled : false}
                />
                {/* <i className="bi bi-eye-fill cursor-pointer p-2 position-absolute" ></i> */}
              </div>
              {Object.keys(errors).length > 0 && (
                <div
                  className="text-danger text-start"
                  style={{ fontSize: "13px" }}
                >
                  {errors[data.name] || ""}
                </div>
              )}
            </div>
          )}
          {data.title === "img" && data?.value && (
            <div className={`col-md-${12 / props?.columns} mb-2`}>
              <label className="form-label d-flex justify-content-start">
                {data.label}
                {data.required && (
                  <span className="text-danger fw-bold mx-2">
                    {data.hide_mandtory_field ? <span></span> : <span>*</span>}
                  </span>
                )}
              </label>
              <div className="col-6">
                {data?.name === "content_uuid" ? (
                  <div className="media-images-list content_img_list m-0 mb-2">
                    {/* {data?.value?.mimetype === "video/mp4" ? (
                      <video className="content_img" controls>
                        <source
                          src={`${S3_BASE_URL}/${data?.value?.media_url}`}
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        className="content_img"
                        alt={data?.value.uuid}
                        src={`${S3_BASE_URL}/${data?.value.media_url}`}
                      ></img>
                    )} */}

                    <div>
                      <span>
                        {data?.value?.display_name?.length > 18
                          ? data?.value?.display_name?.slice(0, 18) + "..."
                          : data?.value?.display_name}
                      </span>
                    </div>
                    <div>
                      <span>
                        {data?.value?.media_name?.length > 18
                          ? data?.value?.media_name?.slice(0, 18) + "..."
                          : data?.value?.media_name}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div>
                    {/* <Carousel showArrows={true} showThumbs={false}>
                      {data?.value?._contents?.map((image: any) => {
                        return (
                          <div className="media-images-list content_img_list m-0 mb-2">
                            {image?.mimetype === "video/mp4" ? (
                              <video className="content_img" controls>
                                <source
                                  src={`${S3_BASE_URL}/${image.media_url}`}
                                  type="video/mp4"
                                />
                              </video>
                            ) : (
                              <img
                                className="content_img"
                                alt={data?.value.uuid}
                                src={`${S3_BASE_URL}/${image.media_url}`}
                              ></img>
                            )}
                            <div>
                              <span>
                                {image?.display_name?.length > 18
                                  ? image?.display_name?.slice(0, 18) + "..."
                                  : image?.display_name}
                              </span>
                            </div>
                            <div>
                              <span>
                                {image?.media_name?.length > 18
                                  ? image?.media_name?.slice(0, 18) + "..."
                                  : image?.media_name}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </Carousel> */}
                  </div>
                )}
              </div>
              <div className="text-center">
                <button
                  onClick={() => onChangeImage(data)}
                  className="custom-bg-btn rounded border-0 px-4 text-white py-1 d-flex justify-content-center me-3"
                >
                  Change
                </button>
              </div>
              {/* <input
                type={data.type}
                name={data.name}
                className="form-control"
                placeholder={data.placeholder}
                onChange={(event) => {
                  handleInput(event, index, data);
                }}
                required={data.required}
                maxLength={data.maxLength}
                value={data.value}
                disabled={data?.disabled ? data?.disabled : false}
              /> */}
              {Object.keys(errors).length > 0 && (
                <div
                  className="text-danger text-start"
                  style={{ fontSize: "13px" }}
                >
                  {errors[data.name] || ""}
                </div>
              )}
            </div>
          )}
          {data.title === "dropdown" && (
            <div className={`col-md-${12 / props?.columns} mb-2`}>
              <label className="form-label d-flex justify-content-start">
                {data?.label} {data?.required}
                {data?.required && (
                  <span className="text-danger fw-bold mx-2">*</span>
                )}
              </label>
              <select
                name={data?.name}
                // className={`form-select custom-select ${
                //   errors?.[data?.name] ? "is-invalid" : ""
                // }`}
                className="form-select custom-select"
                // placeholder={data?.placeholder}
                onChange={(event) => {
                  handleInput(event, index, data);
                }}
                value={data?.value}
              >
                <option value="" disabled={data?.required}>
                  {data?.placeholder}
                </option>
                {data?.option?.map((option: any, index: number) => {
                  return (
                    <option key={index} value={option?.value}>
                      {option?.label}
                    </option>
                  );
                })}
              </select>
              {errors?.[data.name] && (
                <div
                  className="invalid-feedback d-block"
                  style={{ fontSize: "13px" }}
                >
                  {errors[data.name]}
                </div>
              )}
            </div>
          )}

          {data.title === "multiDropdown" && (
            <>
              <div
                className={`col-md-${data?.column ? data?.column : `${12 / props?.columns}`
                  } mb-2`}
              >
                <label className="form-label d-flex justify-content-start">
                  {data.label} {data.required}
                  {data.required && (
                    <span className="text-danger fw-bold mx-2">*</span>
                  )}
                </label>
                {/* <Multiselect
                  placeholder={data.placeholder}
                  options={data.option}
                  selectedValues={data?.value}
                  onSelect={(selectedList: any, selectedItem: any) =>
                    onSelect(selectedList, selectedItem, index, data?.name)
                  }
                  onRemove={(selectedList: any, selectedItem: any) =>
                    onRemove(selectedList, selectedItem, index, data?.name)
                  }
                  isObject={true}
                  avoidHighlightFirstOption={true}
                  showCheckbox={true}
                  hidePlaceholder={false}
                  displayValue="label"
                  customArrow={true}
                  style={{
                    chips: { background: "#074795", marginTop: "4px" },
                    searchBox: {
                      height: "37px",
                      overflow: "hidden",
                      padding: "0px 10px 0px 10px",
                    },
                  }}
                /> */}
                {Object.keys(errors).length > 0 && (
                  <div
                    className="text-danger text-start"
                    style={{ fontSize: "13px" }}
                  >
                    {errors[data.name] || ""}
                  </div>
                )}
              </div>
            </>
          )}
          {data.title === "formArray" && (
            <div className={`col-md-12 mb-2`}>
              <label className="form-label d-flex justify-content-start fw-bold fs-6">
                {data.label}
              </label>
              <div className="px-3 array_form_border">
                {data?.fields?.map((subData: any, subIndex: number) => {
                  return (
                    <div key={subIndex} className="row">
                      {subData?.fields?.map(
                        (subSubData: any, subSubIndex: number) => {
                          return (
                            <React.Fragment key={subSubIndex}>
                              {subSubData.title === "dropdown" && (
                                <div
                                  className={`col-md-${12 / props?.columns
                                    } mb-2`}
                                >
                                  <label className="form-label d-flex justify-content-start">
                                    {subSubData.label} {subSubData.required}
                                    {subSubData.required &&
                                      !subSubData?.hideMandatoryStar && (
                                        <span className="text-danger fw-bold mx-2">
                                          *
                                        </span>
                                      )}
                                  </label>
                                  <select
                                    name={subSubData.name}
                                    className="form-select custom-select border-primary-medium"
                                    onChange={(event) => {
                                      handleInput(event, index, subSubData);
                                    }}
                                    value={subSubData.value}
                                  >
                                    <option
                                      value=""
                                      disabled={subSubData?.required}
                                    >
                                      {subSubData.placeholder}
                                    </option>
                                    {subSubData.option?.map(
                                      (option: any, i: number) => {
                                        return (
                                          <option key={i} value={option?.value}>
                                            {option?.label}
                                          </option>
                                        );
                                      }
                                    )}
                                  </select>
                                  {Object.keys(errors).length > 0 && (
                                    <div
                                      className="text-danger text-start"
                                      style={{ fontSize: "13px" }}
                                    >
                                      {errors[subSubData.name] || ""}
                                    </div>
                                  )}
                                </div>
                              )}
                              {subSubData.title === "input" && (
                                <div
                                  className={`col-md-${subSubData?.column
                                    ? subSubData?.column
                                    : `${12 / props?.columns}`
                                    } mb-2 ${subSubData?.formfloating
                                      ? "form-floating"
                                      : ""
                                    } text-start`}
                                >
                                  {!subSubData?.formfloating && (
                                    <label className="form-label d-flex justify-content-start ">
                                      {subSubData.label}
                                      {subSubData.required &&
                                        !subSubData?.hideMandatoryStar && (
                                          <span className="text-danger fw-bold mx-2">
                                            *
                                          </span>
                                        )}
                                    </label>
                                  )}
                                  <input
                                    type={subSubData.type}
                                    name={subSubData.name}
                                    id={subSubData?.id}
                                    className={`${subSubData.type === "checkbox"
                                      ? ""
                                      : "form-control border-primary-medium"
                                      }`}
                                    placeholder={subSubData.placeholder}
                                    onChange={(event) => {
                                      handleSubElementInput(
                                        event,
                                        index,
                                        subIndex,
                                        subSubIndex,
                                        subSubData,
                                        data
                                      );
                                    }}
                                    required={subSubData.required}
                                    min={subSubData?.min}
                                    maxLength={subSubData.maxLength}
                                    value={subSubData.value}
                                  />
                                  {subSubData?.formfloating && (
                                    <label className="form-label ms-3 d-flex justify-content-start">
                                      {subSubData.label}
                                      {subSubData.required &&
                                        !subSubData?.hideMandatoryStar && (
                                          <span className="text-danger fw-bold mx-2">
                                            *
                                          </span>
                                        )}
                                    </label>
                                  )}
                                  {Object.keys(errors).length > 0 && (
                                    <div
                                      className="text-danger text-start"
                                      style={{ fontSize: "13px" }}
                                    >
                                      {errors[subSubData.name] || ""}
                                    </div>
                                  )}
                                </div>
                              )}
                              {subSubData.title === "textArea" && (
                                <div className={`col-md-${subSubData?.column
                                  ? subSubData?.column
                                  : `${12 / props?.columns}`
                                  } mb-2 ${subSubData?.formfloating
                                    ? "form-floating"
                                    : ""
                                  } text-start`}>
                                  {!subSubData?.formfloating && (
                                    <label className="form-label d-flex justify-content-start ">
                                      {subSubData.label}
                                      {subSubData.required &&
                                        !subSubData?.hideMandatoryStar && (
                                          <span className="text-danger fw-bold mx-2">
                                            *
                                          </span>
                                        )}
                                    </label>
                                  )}
                                  <textarea
                                    name={subSubData.name}
                                    className="form-control"
                                    placeholder={subSubData.placeholder}
                                    onChange={(event) => {
                                      handleSubElementInput(
                                        event,
                                        index,
                                        subIndex,
                                        subSubIndex,
                                        subSubData,
                                        data
                                      );
                                    }}
                                    required={subSubData.required}
                                    maxLength={subSubData.maxLength}
                                    value={subSubData.value}
                                  />
                                  {Object.keys(errors).length > 0 && (
                                    <div
                                      className="text-danger text-start"
                                      style={{ fontSize: "13px" }}
                                    >
                                      {errors[subSubData.name] || ""}
                                    </div>
                                  )}
                                </div>
                              )}
                              {subSubData?.type === "button" && (
                                <div className={`${subSubData?.class}`}>
                                  {subSubData?.buttons.map(
                                    (button: any, btnIndex: number) => {
                                      return (
                                        <button
                                          type="submit"
                                          key={btnIndex}
                                          className={`btn d-flex align-items-center justify-content-center rounded-1 ${button?.class}`}
                                          style={{
                                            width: "30px",
                                            height: "35px",
                                          }}
                                          onClick={(e) =>
                                            onFormSubmit(
                                              e,
                                              button,
                                              index,
                                              subIndex
                                            )
                                          }
                                        >
                                          {button?.icons ? (
                                            <i
                                              className={`${button?.icons}`}
                                              style={{ marginTop: "2.2px" }}
                                            ></i>
                                          ) : (
                                            button?.title
                                          )}
                                        </button>
                                      );
                                    }
                                  )}
                                </div>
                              )}
                            </React.Fragment>
                          );
                        }
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {data.title === "textArea" && (
            <div className={`col-md-${12 / props?.columns} mb-2`}>
              <label className="form-label d-flex justify-content-start">
                {data.label}
                {data.required && (
                  <span className="text-danger fw-bold mx-2">
                    {data.hide_mandtory_field ? <span></span> : <span>*</span>}
                  </span>
                )}
              </label>
              <textarea
                name={data.name}
                className="form-control"
                placeholder={data.placeholder}
                onChange={(event) => {
                  handleInput(event, index, data);
                }}
                required={data.required}
                maxLength={data.maxLength}
                value={data.value}
              />
              {Object.keys(errors).length > 0 && (
                <div
                  className="text-danger text-start"
                  style={{ fontSize: "13px" }}
                >
                  {errors[data.name] || ""}
                </div>
              )}
            </div>
          )}
          {data?.type === 'button' && <div className={`${data?.class}`}>
            {data?.buttons.map((button: any, btnIndex: number) => {
              return <button type="submit" key={btnIndex}
                className={`btn d-block d-lg-inline-block mb-0 mb-lg-0 w-xs-100 rounded-1 ${button?.class}`} onClick={(e) => onFormSubmit(e, button, index, -1)} disabled={button?.isDisabled} >
                {props?.loading ? 'Loading...' : button?.title}
              </button>
            })}
          </div>}
        </React.Fragment>
      ))}

      {/*Show button section only if any button props is provided*/}

      {(props?.custom_btn_text ||
        props?.cancelRoute ||
        props?.customClearButton) && (
          <div
            className={`col-md-${12 / props?.button_columns} ${props?.customClass ? props?.customClass : `d-flex `
              } my-3 text-end`}
          >
            <button
              className={
                props?.custom_btn_text
                  ? `custom-bg-btn rounded border-0 px-4 text-white py-1 justify-content-center me-3`
                  : "border-0 bg-transparent"
              }
              id={props.loading ? "custom-bg-loading" : ""}
              onClick={onClickSubmit}
              disabled={props.loading || isLoading}
            >
              {/* {props?.custom_btn_text
            ? props?.custom_btn_text
            : ""} */}

              {props?.custom_btn_text === "Log In" ? (
                <>
                  {props.loading ? "" : props?.custom_btn_text}
                  {isLoading ||
                    (props.loading && (
                      <div className="text-center px-3">
                        <div
                          className="spinner-border login-spinner-border text-white"
                          role="status"
                        >
                          <span className="sr-only"></span>
                        </div>
                      </div>
                    ))}
                </>
              ) : (
                <>{props?.custom_btn_text}</>
              )}
            </button>
            {props.cancelRoute && (
              <button
                className="custom-cancel-btn rounded border-0 px-4 py-1"
                onClick={onClickCancel}
              >
                Cancel
              </button>
            )}
            {props.customClearButton ? (
              <button
                className="custom-clear-btn rounded border-0 px-4 py-1"
                onClick={onClickClear}
              >
                {props.customClearButton ? props.customClearButton : ""}
              </button>
            ) : (
              <></>
            )}
          </div>
        )}
    </div>
  );
};
